import { render, staticRenderFns } from "./payment-summary.vue?vue&type=template&id=90956e22&scoped=true&"
import script from "./payment-summary.vue?vue&type=script&lang=js&"
export * from "./payment-summary.vue?vue&type=script&lang=js&"
import style0 from "./payment-summary.vue?vue&type=style&index=0&id=90956e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90956e22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90956e22')) {
      api.createRecord('90956e22', component.options)
    } else {
      api.reload('90956e22', component.options)
    }
    module.hot.accept("./payment-summary.vue?vue&type=template&id=90956e22&scoped=true&", function () {
      api.rerender('90956e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/field-template/payment-summary.vue"
export default component.exports